export const unlockTypesLiterals = [
  'wait-timer', // when user waits for the next episode
  'points', // when user uses points
  'unlimited-entitlement', // when user has unlimited entitlement
  'free-book', // when the book is free
  'free', // when the chapter is free
  'dynamic-price-free', // when the chapter is dynamic price free
  'unknown', // when we don't know the unlock type
] as const;
export type UnlockTypes = (typeof unlockTypesLiterals)[number];
